import styled from 'styled-components';

export const Container = styled.div`
    position: relative;
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
    padding-top: 40px;
    min-height: 250px;
`;

export const BackCard = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1;
    transform: translateX(-24px);
`;

export const FrontCard = styled.div`
    position: absolute;
    top: 40px;
    left: 0;
    width: 100%;
    z-index: 2;
    transform: translateX(24px);
`;
